import api from 'api';

export interface BankIntegratorSchema {
  bankName: string;
  banksIntegratorsId: number;
  createdBy: string;
  createdBySp: string;
  createdOn: string;
  helpText: string | null;
  howToBlobFileExtension: string | null;
  howToBlobFileName: string | null;
  howToBlobFileSize: number | null;
  howToBlobGuid: string | null;
  integratorsId: number;
  isActive: boolean;
  logoBlobFileExtension: string | null;
  logoBlobFileName: string | null;
  logoBlobFileSize: number | null;
  logoBlobGuid: string | null;
  modifiedBy: string | null;
  modifiedBySp: string | null;
  modifiedOn: string | null;
  tokenOid: string | null;
  url: string | null;
  urltext: string | null;
}

export const searchBanksIntegratorsByDetails = async (
  payload: Partial<BankIntegratorSchema>,
) => {
  const response: BankIntegratorSchema[] = await api.post(
    'BanksIntegrators/SearchBanksIntegratorsBydetails',
    payload,
  );
  return response;
};

export const getBankIntegratorsFile = (id: string) => {
  return api.get(`/BanksIntegrators/GetBanksIntegratorsFile/${id}`, {
    responseType: 'blob',
  });
};

type VendorCredentialsType = {
  id: number;
  name: string;
  value: string;
  modifiedOn?: string;
};

export interface VendorCredentialsSchema {
  integratorDirectoryId: number;
  bankAccounts_JsonId: number;
  bankAccountsId: number;
  businessesId: number;
  vendorCredentials: VendorCredentialsType[];
  json: string;
  isActive: boolean;
  createdOn: string;
  createdBy: string;
  modifiedOn: string;
  modifiedBy: string;
}

export const getVendorCredentials = (
  banksIntegratorId: number,
  integratorDirectoryId: number,
  businessesId: string,
) => {
  return api.get(
    `/BanksIntegrators/${banksIntegratorId}/Directories/${integratorDirectoryId}/Json`,
    {
      headers: {
        businessesId,
      },
    },
  );
};

export const addVendorCredentials = (
  banksIntegratorId: number,
  integratorDirectoryId: number,
  data: Partial<VendorCredentialsSchema>,
) => {
  return api.post(
    `/BanksIntegrators/${banksIntegratorId}/Directories/${integratorDirectoryId}/Json`,
    data,
  );
};

export const updateVendorCredentials = (
  banksIntegratorId: number,
  integratorDirectoryId: number,
  jsonId: number,
  data: Partial<VendorCredentialsSchema>,
) => {
  return api.put(
    `/BanksIntegrators/${banksIntegratorId}/Directories/${integratorDirectoryId}/Json/${jsonId}`,
    data,
  );
};

export const linkVendorCredentialsToBankAccount = (
  banksIntegratorId: number,
  integratorDirectoryId: number,
  jsonId: number,
  bankAccountId: number,
) => {
  return api.post(
    `/BanksIntegrators/${banksIntegratorId}/Directories/${integratorDirectoryId}/Json/${jsonId}/BankAccounts/${bankAccountId}`,
  );
};
